/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CheckEntitlements_OfferingEntitlementsQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
  withPrivateOfferings: Types.Scalars['Boolean']['input'];
}>;

export type CheckEntitlements_OfferingEntitlementsQuery = {
  readonly __typename?: 'Query';
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly syndicate?: {
        readonly __typename?: 'SyndicateFull';
        readonly managers: ReadonlyArray<{
          readonly __typename?: 'ManagerFull';
          readonly id: string;
          readonly cmgEntityKey: string;
          readonly entitlements?: ReadonlyArray<string> | null;
        }>;
      } | null;
    }> | null;
  } | null;
  readonly privateOfferings?: {
    readonly __typename?: 'PrivateOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly syndicate?: {
        readonly __typename?: 'SyndicateFull';
        readonly managers: ReadonlyArray<{
          readonly __typename?: 'ManagerFull';
          readonly id: string;
          readonly cmgEntityKey: string;
          readonly entitlements?: ReadonlyArray<string> | null;
        }>;
      } | null;
    }> | null;
  } | null;
};

export const CheckEntitlements_OfferingEntitlementsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CheckEntitlements_OfferingEntitlements' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withPrivateOfferings' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includePrivatePlacementOfferings' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'syndicate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'managers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entitlements' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: {
                      kind: 'Variable',
                      name: { kind: 'Name', value: 'withPrivateOfferings' },
                    },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'syndicate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'managers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entitlements' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCheckEntitlements_OfferingEntitlementsQuery__
 *
 * To run a query within a React component, call `useCheckEntitlements_OfferingEntitlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckEntitlements_OfferingEntitlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckEntitlements_OfferingEntitlementsQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *      withPrivateOfferings: // value for 'withPrivateOfferings'
 *   },
 * });
 */
export function useCheckEntitlements_OfferingEntitlementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckEntitlements_OfferingEntitlementsQuery,
    CheckEntitlements_OfferingEntitlementsQueryVariables
  > &
    (
      | { variables: CheckEntitlements_OfferingEntitlementsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckEntitlements_OfferingEntitlementsQuery,
    CheckEntitlements_OfferingEntitlementsQueryVariables
  >(CheckEntitlements_OfferingEntitlementsDocument, options);
}
export function useCheckEntitlements_OfferingEntitlementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckEntitlements_OfferingEntitlementsQuery,
    CheckEntitlements_OfferingEntitlementsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckEntitlements_OfferingEntitlementsQuery,
    CheckEntitlements_OfferingEntitlementsQueryVariables
  >(CheckEntitlements_OfferingEntitlementsDocument, options);
}
// @ts-ignore
export function useCheckEntitlements_OfferingEntitlementsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckEntitlements_OfferingEntitlementsQuery,
    CheckEntitlements_OfferingEntitlementsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  CheckEntitlements_OfferingEntitlementsQuery,
  CheckEntitlements_OfferingEntitlementsQueryVariables
>;
export function useCheckEntitlements_OfferingEntitlementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckEntitlements_OfferingEntitlementsQuery,
        CheckEntitlements_OfferingEntitlementsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  CheckEntitlements_OfferingEntitlementsQuery | undefined,
  CheckEntitlements_OfferingEntitlementsQueryVariables
>;
export function useCheckEntitlements_OfferingEntitlementsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckEntitlements_OfferingEntitlementsQuery,
        CheckEntitlements_OfferingEntitlementsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckEntitlements_OfferingEntitlementsQuery,
    CheckEntitlements_OfferingEntitlementsQueryVariables
  >(CheckEntitlements_OfferingEntitlementsDocument, options);
}
export type CheckEntitlements_OfferingEntitlementsQueryHookResult = ReturnType<
  typeof useCheckEntitlements_OfferingEntitlementsQuery
>;
export type CheckEntitlements_OfferingEntitlementsLazyQueryHookResult = ReturnType<
  typeof useCheckEntitlements_OfferingEntitlementsLazyQuery
>;
export type CheckEntitlements_OfferingEntitlementsSuspenseQueryHookResult = ReturnType<
  typeof useCheckEntitlements_OfferingEntitlementsSuspenseQuery
>;
export type CheckEntitlements_OfferingEntitlementsQueryResult = Apollo.QueryResult<
  CheckEntitlements_OfferingEntitlementsQuery,
  CheckEntitlements_OfferingEntitlementsQueryVariables
>;

import { makeMockResponse } from '../../../../../graphql/mock-response';

export const makeCheckEntitlements_OfferingEntitlementsMockResponse = makeMockResponse<
  CheckEntitlements_OfferingEntitlementsQueryVariables,
  CheckEntitlements_OfferingEntitlementsQuery
>(CheckEntitlements_OfferingEntitlementsDocument);
